import { applyStyle } from '../css';
import { icons } from '../icons';
import { createConnectionBadge } from './badge';
export function createTopbar(opts) {
    const top = document.createElement('header');
    top.classList.add('pr-topbar');
    // Mobile hamburger — sadece ≤768px'de görünür (CSS media query).
    if (opts.onMenuToggle) {
        const burger = document.createElement('button');
        burger.type = 'button';
        burger.classList.add('pr-hamburger', 'pr-mobile-only');
        burger.setAttribute('aria-label', 'Menü');
        burger.innerHTML = `
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor"
           stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <line x1="3" y1="6" x2="21" y2="6"/>
        <line x1="3" y1="12" x2="21" y2="12"/>
        <line x1="3" y1="18" x2="21" y2="18"/>
      </svg>`;
        burger.addEventListener('click', () => opts.onMenuToggle?.());
        top.append(burger);
    }
    // Breadcrumb
    const crumbs = document.createElement('div');
    crumbs.classList.add('pr-topbar-breadcrumb');
    applyStyle(crumbs, {
        display: 'flex',
        alignItems: 'center',
        gap: 'var(--sp-2)',
        fontSize: 'var(--fs-caption)',
        letterSpacing: '0.16em',
        fontWeight: '500',
        color: 'var(--text-tertiary)',
        minWidth: '0',
    });
    opts.breadcrumbs.forEach((c, i) => {
        const span = document.createElement('span');
        span.textContent = c.label.toUpperCase();
        if (c.active) {
            applyStyle(span, { color: 'var(--text-primary)', fontWeight: '600' });
        }
        crumbs.append(span);
        if (i < opts.breadcrumbs.length - 1) {
            const sep = document.createElement('span');
            sep.textContent = '/';
            applyStyle(sep, { color: 'var(--text-tertiary)' });
            crumbs.append(sep);
        }
    });
    top.append(crumbs);
    // Arama kutusu (mobile'da CSS ile gizli)
    const searchWrap = document.createElement('div');
    searchWrap.classList.add('pr-topbar-search');
    applyStyle(searchWrap, {
        flex: '1',
        maxWidth: '480px',
        margin: '0 auto',
        position: 'relative',
        display: 'flex',
        alignItems: 'center',
    });
    const searchIcon = document.createElement('span');
    searchIcon.innerHTML = icons.search();
    applyStyle(searchIcon, {
        position: 'absolute',
        left: '12px',
        color: 'var(--text-tertiary)',
        pointerEvents: 'none',
        display: 'flex',
    });
    const searchInput = document.createElement('input');
    searchInput.type = 'text';
    searchInput.placeholder = opts.searchPlaceholder ?? 'Kişi, cihaz veya ID ara...';
    applyStyle(searchInput, {
        width: '100%',
        height: '36px',
        padding: '0 var(--sp-7) 0 38px',
        fontSize: 'var(--fs-body)',
        background: 'var(--bg-elev-2)',
        border: '1px solid var(--border-subtle)',
        borderRadius: 'var(--radius-sm)',
        color: 'var(--text-primary)',
    });
    const kbdHint = document.createElement('span');
    kbdHint.textContent = '⌘K';
    applyStyle(kbdHint, {
        position: 'absolute',
        right: '12px',
        fontSize: 'var(--fs-tiny)',
        fontFamily: 'var(--font-mono)',
        color: 'var(--text-tertiary)',
        background: 'var(--bg-elev-3)',
        border: '1px solid var(--border-subtle)',
        borderRadius: '4px',
        padding: '2px 6px',
        pointerEvents: 'none',
    });
    searchWrap.append(searchIcon, searchInput, kbdHint);
    top.append(searchWrap);
    // Sağ taraf
    const right = document.createElement('div');
    applyStyle(right, {
        display: 'flex',
        alignItems: 'center',
        gap: 'var(--sp-3)',
        marginLeft: 'auto',
    });
    if (opts.connection) {
        const badge = createConnectionBadge(opts.connection);
        badge.classList.add('pr-conn-badge');
        right.append(badge);
    }
    const iconBar = document.createElement('div');
    iconBar.classList.add('pr-topbar-iconbar');
    applyStyle(iconBar, { display: 'flex', alignItems: 'center', gap: 'var(--sp-1)' });
    for (const [name, html] of [
        ['Bildirim', icons.bell()],
        ['Yardım', icons.help()],
        ['Tema', icons.moon()],
    ]) {
        const ib = document.createElement('button');
        ib.type = 'button';
        ib.innerHTML = html;
        ib.title = name;
        applyStyle(ib, {
            background: 'transparent',
            border: '1px solid transparent',
            borderRadius: 'var(--radius-sm)',
            color: 'var(--text-tertiary)',
            cursor: 'pointer',
            padding: '6px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            transition: 'background var(--motion-fast), color var(--motion-fast)',
        });
        ib.addEventListener('mouseenter', () => {
            ib.style.background = 'var(--bg-elev-3)';
            ib.style.color = 'var(--text-primary)';
        });
        ib.addEventListener('mouseleave', () => {
            ib.style.background = 'transparent';
            ib.style.color = 'var(--text-tertiary)';
        });
        iconBar.append(ib);
    }
    right.append(iconBar);
    if (opts.rightSlot)
        right.append(opts.rightSlot);
    top.append(right);
    return top;
}
